import { requestGet, requestPost, requestFormPost } from '@/common/request';
import { fetchFormPost } from '../../resource-position-manage/request';

const prefix_domain = 'generic/sourcecms/resource';
const prefix_material_domain = 'generic/sourcecms/materialManage';

export default {
  // 创建商品组createProductGroup
  createProductGroup(data) {
    // return fetchFormPost('service/createProductGroup', data);
    return requestFormPost(`/${prefix_material_domain}/createProductGroup`, { body: JSON.stringify(data) });
  },
  createAdvertGroup(data) {
    // return fetchFormPost('service/createProductGroup', data);
    return requestFormPost(`/${prefix_material_domain}/createAdvertGroup`, { body: JSON.stringify(data) });
  },
  // 编辑商品组
  editProductGroup(data) {
    // return fetchFormPost('service/editProductGroup', data);
    return requestFormPost(`/${prefix_material_domain}/editProductGroup`, { body: JSON.stringify(data) });
  },
  // 编辑广告组
  editAdvertGroup(data) {
    // return fetchFormPost('service/editAdvertGroup', data);
    return requestFormPost(`/${prefix_material_domain}/editAdvertGroup`, { body: JSON.stringify(data) });
  },

  // 分享商品组shareProductAuthority
  shareProductAuthority(data) {
    // return fetchFormPost('service/shareProductAuthority', data);
    return requestFormPost(`/${prefix_material_domain}/shareProductAuthority`, { body: JSON.stringify(data) });
  },

  // 分享广告组shareAdvertAuthority
  shareAdvertAuthority(data) {
    // return fetchFormPost('service/shareAdvertAuthority', data);
    return requestFormPost(`/${prefix_material_domain}/shareAdvertAuthority`, { body: JSON.stringify(data) });
  },

  // 删除广告组商品组 archiveGroup
  archiveGroup(data) {
    // return fetchFormPost('service/archiveGroup', data);
    return requestFormPost(`/${prefix_material_domain}/archiveGroup`, { body: JSON.stringify(data) });
  },
  // 资源上场列表页查询 resourceQueryMaterialList
  resourceQueryMaterialList(data) {
    // return fetchFormPost('service/resourceQueryMaterialList', data);
    return requestFormPost(`/${prefix_domain}/resourceQueryMaterialList`, { body: JSON.stringify(data) });
  },

  // 去关联 查询资源位关联通天塔的页面 resourceQueryBindInfosByResource
  resourceQueryBindInfosByResource(data) {
    // return fetchFormPost('service/resourceQueryBindInfosByResource', data);
    return requestFormPost(`/${prefix_domain}/resourceQueryBindInfosByResource`, { body: JSON.stringify(data) });
  },

  // 批量导入 resourceBatchAddMaterial
  resourceBatchAddMaterial(data) {
    // return fetchFormPost('service/resourceQueryBindInfosByResource', data);
    return requestFormPost(`/${prefix_domain}/resourceBatchAddMaterial`, { body: JSON.stringify(data) });
  },

  // 素材组 级联queryMatCascadeList
  queryMatCascadeList(data) {
    return requestFormPost(`/${prefix_material_domain}/queryMatCascadeList`, { body: JSON.stringify(data) });
  },
  // 广告组样式
  queryMaterialErpWhiteList(data) {
    return requestFormPost(`/${prefix_material_domain}/queryMaterialErpWhiteList`, { body: JSON.stringify(data) });
  },
  // 关联 resourceBindGroupWithResourceId

  resourceBindGroupWithResourceId(data) {
    return requestFormPost(`/${prefix_domain}/resourceBindGroupWithResourceId`, { body: JSON.stringify(data) });
  },

  // queryBabelStyleInfo
  queryBabelStyleInfo(data) {
    return requestFormPost(`/${prefix_material_domain}/queryBabelStyleInfo`, { body: JSON.stringify(data) });
  },

  // 移动资源位 resourceTransferMaterial
  resourceTransferMaterial(data) {
    return requestFormPost(`/${prefix_domain}/resourceTransferMaterial`, { body: JSON.stringify(data) });
  },

  // 查询规则详细信息resourceQuerySourceInfo
  resourceQuerySourceInfo(data) {
    return requestFormPost(`/${prefix_domain}/resourceQuerySourceInfo`, { body: JSON.stringify(data) });
  },

  // ducc  /service/duccInfo
  duccInfo(data) {
    return requestFormPost(`/${prefix_material_domain}/duccInfo`, { body: JSON.stringify(data) });
  },

  // 初始状况判定 resourceQueryMaterialNumById
  resourceQueryMaterialNumById(data) {
    // return fetchFormPost('service/resourceQueryMaterialNumById', data);
    return requestFormPost(`/${prefix_domain}/resourceQueryMaterialNumById`, { body: JSON.stringify(data) });
  },

  // plus关联楼层 groupAssociation
  groupAssociation(data) {
    return requestFormPost(`/${prefix_material_domain}/groupAssociation`, { body: JSON.stringify(data) });
  },
  // 营销活动 sourcecms/resource/activityPlanList
  activityPlanList(data) {
    return requestFormPost(`/${prefix_domain}/activityPlanList`, { body: JSON.stringify(data) });
  },
};
